export const MFA_ROLES = [
  { value: 'translator', label: 'translator' },
  { value: 'organization_admin', label: 'organization_admin' },
  { value: 'country_admin', label: 'country_admin' },
  { value: 'regional_admin', label: 'regional_admin' },
  { value: 'phc_service_admin', label: 'phc_service_admin' },
  { value: 'clinic_admin', label: 'clinic_admin' },
  { value: 'therapist', label: 'therapist' },
  { value: 'phc_worker', label: 'phc_worker' },
];
